import { theme } from 'theme'

export const colorMap = (key?: string) =>
  theme.palette.events[key as keyof typeof theme.palette.events] ?? 'lightblue'

export default colorMap
